import PopupForm from "app/common/Component/Popup/PopupForm";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo } from "react";
import TableComponent from "app/common/Component/Table/TableComponent";
import { formatMoney, getPositionCodes } from "app/common/LocalFunction";
import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { pagingStaff } from "app/services/StaffService";
import { useStore } from "app/stores";
import TotalOfVoucherByUpdate from "../Component/TotalOfVoucherByUpdate";
import CommonButton from "app/common/Component/Button/CommonButton";
import { Block, Save } from "@material-ui/icons";
import { VOUCHER_INVOICE_TYPE_VALUE } from "app/common/LocalConst";
import GlobitsConfirmationDialog from "app/common/GlobitsConfirmationDialog";
import StaffRevenuesFee from "../Component/StaffRevenuesFee";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import { PathModule } from "app/common/LocalConst";
import Config from "app/appConfig";
const VoucherTemporaryPopup = ({
  open,
  handleClose,
  detailData,
  editable = false,
  setOpenStaffRevenueUpdate,
  handleUpdateVoucher,
  listStk,
  patientId,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <PopupForm
      open={open}
      size="xxl"
      handleClose={handleClose}
      title={"Danh sách phiếu chi tiết"}
      // hideFooter={true}
      formik={{
        initialValues: {
          ...detailData,
        },
        onSubmit: handleUpdateVoucher,
        enableReinitialize: true,
      }}
      action={({ isSubmitting, values }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" disabled={isSubmitting}>
              {!isMobile && <Save className="mr-2 " />}
              {isSubmitting ? "Đang cập nhật..." : "Cập nhật"}
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ values, setFieldValue }) => (
        <>
          <ValueForm
            editable={editable}
            setOpenStaffRevenueUpdate={setOpenStaffRevenueUpdate}
            listStk={listStk}
          />

          <DialogError patientId={patientId} setFieldValue={setFieldValue} />
        </>
      )}
    </PopupForm>
  );
};

const ValueForm = ({ editable, listStk }) => {
  const { values, setFieldValue } = useFormikContext();
  let POSITION_CODES = getPositionCodes();
  let isAdvance =
    VOUCHER_INVOICE_TYPE_VALUE.Advance === values?.voucherInvoiceType;

  return (
    <Grid container spacing={1}>
      <Grid item xs={8}>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={3}>
            <GlobitsTextField label={"Mã phiếu"} name="code" disabled />
          </Grid>
          <Grid item xs={12} lg={3}>
            <GlobitsPagingAutocomplete
              label={"Cơ sở"}
              name="department"
              disabled
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <GlobitsPagingAutocomplete
              label="Người lập"
              name="accountant"
              displayLabel="staffName"
              api={pagingStaff}
              disabled
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <GlobitsDateTimePicker
              label={"Thời gian tạo phiếu"}
              name="voucherDate"
              isDateTimePicker
              disabled
            />
          </Grid>

          <Grid item xs={12} lg={3}>
            <GlobitsVNDCurrencyInput
              label={`${values?.voucherInvoiceType === VOUCHER_INVOICE_TYPE_VALUE.Refund
                  ? "Tổng chi"
                  : "Tổng thu"
                } `}
              name="totalAmount"
              disabled
            />
          </Grid>
          {!isAdvance && (
            <>
              <Grid item xs={12} lg={3}>
                <GlobitsVNDCurrencyInput
                  label={"Giảm giá tổng hóa đơn"}
                  name="allocateDiscount"
                  disabled
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <GlobitsVNDCurrencyInput
                  label={"Tiền thu sau giảm"}
                  name="moneyAfterDiscount"
                  disabled
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <TotalOfVoucherByUpdate
          nameSpace={"voucherPaymentMethods"}
          listStk={listStk}
          moneyAfterDiscount={values?.moneyAfterDiscount}
        // editable={editable}
        />
      </Grid>

      <Grid item xs={12}>
        <TableComponent
          className=""
          showOrdinalNumbers
          titleNodata={"noData"}
          data={values?.items || []}
          columns={[
            {
              field: "content",
              title: "Tên dịch vụ",
              render: (row) => {
                return (
                  <>
                    <div>{row?.content}</div>
                    <div className="flex mt-2">
                      <div>
                        Thu:{" "}
                        <b style={{ color: "red" }}>
                          {formatMoney(row?.amount)}
                        </b>
                      </div>
                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        Cần thu:{" "}
                        <b style={{ color: "green" }}>
                          {formatMoney(row?.moneyAfterDiscount || 0)}
                        </b>
                      </div>
                    </div>
                  </>
                );
              },
            },

            {
              field: "content",
              title: "Phân bổ doanh thu (nhân viên)",

              render: (row, index) => (
                <div className="staff-list">
                  <div style={{ width: "100%" }}>
                    <StaffRevenuesFee
                      editable={true}
                      index={index}
                      row={row}
                      POSITION_CODES={POSITION_CODES}
                    />
                  </div>
                </div>
              ),
            },
          ]}
        />
      </Grid>
    </Grid>
  );
};

const DialogError = observer(({ patientId, values, setFieldValue }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().feeStore.serviceFeeTabStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            setFieldValue("voucherDate", values?.voucherDate);
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${patientId}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Thao tác thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});
export default memo(observer(VoucherTemporaryPopup));
